import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/users/$userId')({
  component: () => <Navigate replace search from="/bak/users/$userId" to="/bo/users/$userId" />,
})
